import React, { useEffect, useState } from "react";
import "./SocialAppBrowserModal.css";
import { isIOSDevice } from "../utils/isSocialAppBrowser";

const SocialAppBrowserModal = ({ isOpen, onClose }) => {
  const [copied, setCopied] = useState(false);
  const isIOS = isIOSDevice();

  useEffect(() => {
    if (!isOpen) return undefined;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    } catch {
      const input = document.createElement("input");
      input.value = window.location.href;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    }
  };

  return (
    <div className="social-browser-modal" role="dialog" aria-modal="true">
      <div className="social-browser-modal-content">
        <p className="modal-label">Browser notice</p>
        <h2 className="modal-heading">Open in your regular browser</h2>
        <p className="modal-subheading">
          You opened this page from Facebook. For the best experience, open it in
          Safari or Chrome.
        </p>

        <ol className="modal-steps">
          {isIOS ? (
            <>
              <li>Tap the <strong>⋯</strong> menu (bottom right)</li>
              <li>Select <strong>Open in browser</strong> or <strong>Open in Safari</strong></li>
            </>
          ) : (
            <>
              <li>Tap the <strong>⋯</strong> menu (top right)</li>
              <li>Select <strong>Open in Chrome</strong> or <strong>Open in external browser</strong></li>
            </>
          )}
        </ol>

        <p className="modal-body-text">
          Or copy the link below and paste it into Safari or Chrome.
        </p>

        <button className="theme-btn" type="button" onClick={handleCopyLink}>
          {copied ? "Link copied!" : "Copy link"}
        </button>

        <button className="dismiss-btn" type="button" onClick={onClose}>
          Continue here anyway
        </button>
      </div>
    </div>
  );
};

export default SocialAppBrowserModal;
